import { useEffect, useState } from 'react'

// inspired by checkout's useDarkMode
export const useDarkMode = (): [boolean, boolean] => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false)
  const [mounted, setMounted] = useState<boolean>(false)

  useEffect(() => {
    const darkMode = window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
    setIsDarkMode(darkMode)
    setMounted(true)
  }, [])

  return [isDarkMode, mounted]
}
